import { Alert } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

export const MfaErrorToastAlert = styled(Alert)`
  width: 100%;
`;

export const MfaModalConfirmSpinnerIcon = styled(FontAwesomeIcon)`
  font-size: 18px;
`;

export const MfaRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const MfaContent = styled.div`
  flex: 1;
`;

export const MfaLabel = styled.div`
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 4px;
`;

export const MfaDescription = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.greyMedium};
  line-height: 20px;
  margin-bottom: 8px;
`;

export const InactiveStatusText = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.greyMedium};
`;

export const MfaToggleSpinner = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.greyMedium};
  font-size: 20px;
  padding: 9px;
`;

export const DialogButtonRow = styled.div`
  display: flex;
  gap: 8px;
`;

export const EnableMethodInfo = styled.div`
  padding: 14px 16px 16px;
  margin: 8px 24px 16px;
  border: 2px solid ${({ theme }) => theme.primaryColor};
  border-radius: 8px;
  background: ${({ theme }) => theme.greenPastel};
  text-align: left;
`;

export const EnableMethodTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 2px;
  color: ${({ theme }) => theme.greyBase};
`;

export const EnableMethodDescription = styled.div`
  font-size: 14px;
  line-height: 18px;
  color: ${({ theme }) => theme.greyMedium};
`;

export const ActiveMethodText = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.greenDark};
  font-weight: 500;
`;
